export const LOAN_STATUS_LABEL_ALL_CLOSED_LOANS = "All Closed Loans";
